<template>
	<div class="page">
		<div class="pic">
			{{productDetail.covers[coverActive].img}}
			<img v-if="productDetail.covers && productDetail.covers.length > 0"
				:src="productDetail.covers[coverActive].image" />
		</div>
		<div class="covers" v-if="productDetail.covers && productDetail.covers.length > 1">
			<div @click="changeCover(index)" :class="{'item': true, 'active': index === coverActive}"
				v-for="(cover, index) in productDetail.covers" :key="cover.id">
				<img :src="cover.image" />
			</div>
		</div>
		<div class="brand" v-if="productDetail.brand && productDetail.brand.name">{{productDetail.brand.name}}</div>
		<div class="name" v-if="productDetail.name">{{productDetail.name}}</div>
		<div class="desc-box">
			<div class="title">
				<div class="line"></div>养研360品鉴
			</div>
			<div class="description">
				<div class="level-new" v-if="productDetail.purity && productDetail.purity.level">
					<div class="label">含量类型</div>
					<div class="tip">
						<span :class="{'active': productDetail.purity.level === 1}">普通型</span>
						<span :class="{'active': productDetail.purity.level === 2}">高浓度</span>
					</div>
				</div>
				{{productDetail.description}}
			</div>
		</div>
		<div class="box-show">
			<div class="proportions">
				<div class="title">
					<div class="line"></div>核心成分分析
				</div>
				<div class="thead">
					<div>营养成分</div>
					<div>含量</div>
				</div>
				<div class="tbody" v-if="productDetail.main_proportions">
					<div class="item" v-for="(proportion, index) in productDetail.main_proportions"
						:key="proportion.id">
						<div>{{proportion.title}}</div>
						<div>{{proportion.value}}{{proportion.get_unit_display || ''}}/{{proportion.get_per_display}}
						</div>
					</div>
				</div>
				<div class="other">
					<div class="sub_title">其他成分</div>
					<span v-for="(proportion, index) in productDetail.extra_proportions"
						:key="proportion.id">{{proportion.title}}</span>
				</div>
			</div>
		</div>

		<div class="title-new">
			<div class="line"></div>服用方法
		</div>
		<div class="details" v-if="productDetail.details">
			<div class="item" v-for="(item, index) in productDetail.details" :key="item.id">
				<div class="label">{{item.get_title_display}}</div>
				<div class="span">{{item.content}}</div>
			</div>
		</div>

		<template v-if="productDetail.specs && productDetail.specs.length > 0">
			<div class="title-new">
				<div class="line"></div>规格
			</div>
			<div class="specs">
				<div :class="{'item': true, 'active':specActive === spec.id}"
					v-for="(spec, index) in productDetail.specs" :key="spec.id" @click="specChange(spec.id)">
					{{spec.title}}
				</div>
			</div>
			<div class="details" v-if="productDetail.details">
				<div class="item">
					<div class="label">价格</div>
					<div v-if="productDetail.specs" class="span">¥ {{price}} ( ¥ {{dayPrice}}/{{unit}} )</div>
				</div>
			</div>
		</template>


		<div class="title-new">
			<div class="line"></div>原厂标签
		</div>
		<div class="com_pic">
			<img :src="productDetail.label_img"></img>
		</div>

	</div>
</template>

<script>
	import '@/assets/css/public.css';
	import {
		getDetail
	} from '@/axios/api.js'
	export default {
		data() {
			return {
				id: null,
				specActive: null,
				tabs: ['概览信息', '详细数据'],
				tabActive: 0,
				coverActive: 0,
				price: null,
				dayPrice: null,
				unit: '',
				productDetail: {},
				isShowName: true,
				chartData: {},
				option: {},
				isShowTip: false,
				isMobile: undefined
			}
		},
		created() {
			this.get()
		},
		mounted() {
			this.set()
			window.onresize = () => {
				return (() => {
					this.set()
				})()
			}
		},
		methods: {
			set() {
				if (document.body.clientWidth < 768) {
					this.isMobile = true
					document.documentElement.style.fontSize = 100 + 'px';
				} else {
					this.isMobile = false
				}
			},
			get() {
				getDetail(this.$route.query.id).then(res => {
					console.log(res)
					this.productDetail = res.data.product
					if (res.data.product.specs && res.data.product.specs.length > 0) {
						this.specActive = res.data.product.specs[0].id
						this.price = res.data.product.specs[0].price
						this.dayPrice = res.data.product.specs[0].day_price
						this.unit = res.data.product.specs[0].get_day_price_unit_display
					}
				})
			},

			specChange(id) {
				this.specActive = id
				const obj = this.productDetail.specs.find(item => item.id === id)
				this.price = obj.price
				this.dayPrice = obj.day_price
				this.unit = obj.get_day_price_unit_display
			},
			tabChange(index) {
				this.tabActive = index
			},
			changeCover(index) {
				this.coverActive = index
			},
			showTip() {
				this.isShowTip = true
			},
			closeTip() {
				this.isShowTip = false
			},
		},
	}
</script>

<style lang="less">
	.pic {
		margin-bottom: .2rem;
		display: flex;
		align-items: center;
		justify-content: center;
		overflow: hidden;

		img {
			width: 3.7rem;
			height: 3.7rem;
			overflow: hidden;
		}
	}

	.brand {
		padding: 0 0 0 .2rem;
		font-size: .14rem;
		font-weight: 300;
		margin-bottom: 0.05rem;
	}

	.name {
		padding: 0 0 0 .2rem;
		font-size: .18rem;
		font-weight: 400;
		margin-bottom: .2rem;
	}

	.specs {
		display: flex;
		align-items: center;
		padding: 0 .2rem;
		margin-bottom: .10rem;

		.item {
			font-weight: 300;
			margin-right: .1rem;
			height: .24rem;
			line-height: .24rem;
			border-radius: .12rem;
			font-size: .12rem;
			padding: 0 .1rem;
			background: #f5f5f7;


			&.active {
				color: #333;
				background-image: linear-gradient(90deg, #CC99EA 0%, #FDF19D 100%);
				font-weight: 400;
			}
		}
	}

	.details {
		background: #F8F8F8;
		margin: 0 .2rem .2rem .2rem;
		padding: .15rem;
		border-radius: .1rem;
		font-weight: 400;

		.item {
			display: flex;
			align-items: flex-start;
			font-size: .14rem;
			padding: .05rem 0;

			.label {
				color: rgba(0, 0, 0, 0.75);
				font-size: .13rem;
			}

			.span {
				margin-left: 1.40rem;
				flex: 1;
				text-align: right;
				color: rgba(0, 0, 0, 0.5);
				font-size: .13rem;
			}
		}
	}


	.title-new {
		display: flex;
		align-items: center;
		font-weight: 500;
		margin: 0 .2rem .1rem .2rem;

		.line {
			margin-right: .08rem;
			background: #D490FF;
			width: .04rem;
			height: .10rem;
			border-radius: .02rem;
		}
	}

	.proportions {
		margin: 0 .20rem;

		.title {
			margin-bottom: .1rem;
			display: flex;
			align-items: center;
			font-weight: 500;

			.line {
				margin-right: .08rem;
				background: #D490FF;
				width: .04rem;
				height: .10rem;
				border-radius: .02rem;
			}
		}

		.thead {
			background: #F8F8F8;
			display: flex;
			font-size: .14rem;
			border-radius: .05rem;
			height: .30rem;
			align-items: center;
			color: rgba(0, 0, 0, 0.4);
			font-size: .13rem;

			div {
				&:nth-child(1) {
					margin-left: .10rem;
					flex: 1;
				}

				&:nth-child(2) {
					margin-right: .10rem;
					text-align: right;
				}

			}

		}

		.tbody {
			padding: .10rem 0;
			border-bottom: rgba(0, 0, 0, 0.09) 1px solid;
			margin-bottom: .20rem;
			font-size: .13rem;
			color: rgba(0, 0, 0, 0.75);

			.item {
				display: flex;
				padding: .05rem 0;

				div {
					&:nth-child(1) {
						margin-left: .10rem;
						flex: 1;
					}

					&:nth-child(2) {
						margin-right: .10rem;
						text-align: right;
					}

				}
			}
		}

		.other {
			padding-bottom: .40rem;
			margin: 0 .10rem;

			.sub_title {
				margin-bottom: .10rem;
				color: rgba(0, 0, 0, 0.5);
			}

			span {
				margin-right: .30rem;
				display: inline-block;
				margin-bottom: .10rem;
				font-size: .13rem;
				color: rgba(0, 0, 0, 0.75);
			}
		}
	}



	.covers {
		display: flex;
		align-items: center;
		margin-bottom: .4rem;
		padding: 0.2rem 0.4rem 0 0.2rem;

		.item {
			width: 0.3rem;
			height: 0.3rem;
			border: #ffffff 1px solid;
			margin-right: 0.1rem;
			border-radius: .1rem;
			padding: 0.1rem;

			img {
				width: 0.3rem;
				height: 0.3rem;
			}

			&.active {
				border: #ccc 1px solid;
			}
		}
	}

	.chart-box {
		padding: 40upx 0;
	}

	.page {
		padding-bottom: .4rem;
	}




	.box-show {
		overflow: hidden;
	}

	.desc-box {
		margin: 0 .2rem .2rem .2rem;

		.title {
			margin-bottom: .1rem;
			display: flex;
			align-items: center;
			font-weight: 500;

			.line {
				margin-right: .08rem;
				background: #D490FF;
				width: .04rem;
				height: .10rem;
				border-radius: .02rem;
			}
		}

		.description {
			background: #F8F8F8;
			border-radius: .1rem;
			font-weight: 400;
			font-size: .14rem;
			padding: .15rem .15rem;
			line-height: 1.6;
			text-align: justify;
			color: #888;
		}
	}

	.com_pic {
		margin: 0 .20rem;

		img {
			display: block;
			width: 100%;
			height: auto;
		}
	}

	.level-new {
		display: flex;
		align-items: center;
		justify-content: space-between;
		margin-bottom: .10rem;
		border-bottom: #e5e5e5 1px solid;
		padding-bottom: .1rem;

		.label {
			color: #333;
		}

		.tip {
			span {
				margin-left: .1rem;
				color: #ccc;

				&.active {
					font-weight: 500;
					color: #CC99EA;
				}
			}
		}
	}
</style>
